"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Popover;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactTransitionGroup = require("react-transition-group");

require("./_style.scss");

var _useCloseWhenClickedOutside = _interopRequireDefault(require("../../hooks/useCloseWhenClickedOutside"));

var _DefaultButton = _interopRequireDefault(require("./DefaultButton"));

function Popover(props) {
  var _props$caretPosition = props.caretPosition,
      caretPosition = _props$caretPosition === void 0 ? "top-right" : _props$caretPosition,
      showPopover = props.showPopover,
      setShowPopover = props.setShowPopover,
      _props$buttonChild = props.buttonChild,
      buttonChild = _props$buttonChild === void 0 ? /*#__PURE__*/_react["default"].createElement(_DefaultButton["default"], {
    showPopover: showPopover,
    setShowPopover: setShowPopover
  }) : _props$buttonChild,
      _props$zIndex = props.zIndex,
      zIndex = _props$zIndex === void 0 ? 666 : _props$zIndex,
      children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      rest = (0, _objectWithoutProperties2["default"])(props, ["caretPosition", "showPopover", "setShowPopover", "buttonChild", "zIndex", "children", "className"]);
  var node = (0, _useCloseWhenClickedOutside["default"])(function () {
    return setShowPopover(false);
  });
  var buttonParent = (0, _react.useRef)();
  var style = calculateStyle(buttonParent, caretPosition, zIndex);
  var slideDirection = caretPosition.startsWith("top") ? "slide-down" : "slide-up";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__popover-container ".concat(className),
    ref: node
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: buttonParent
  }, buttonChild), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, Object.assign({
    style: style,
    classNames: "nstyle__popover--".concat(slideDirection),
    "in": showPopover,
    timeout: 300,
    unmountOnExit: true
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__popover--".concat(caretPosition, " nstyle__popover")
  }, children)));
}

function calculateStyle(parent, caretPosition, zIndex) {
  var _parent$current, _parent$current2;

  // parent is undefined on 1st call because the Popover hasn't rendered the buttonChild yet
  // buttonParent updates immediately after the first render, once it exists in the DOM
  var parentHeight = (_parent$current = parent.current) === null || _parent$current === void 0 ? void 0 : _parent$current.offsetHeight;
  var parentWidth = (_parent$current2 = parent.current) === null || _parent$current2 === void 0 ? void 0 : _parent$current2.offsetWidth;
  var calculatedBottomOffset = "".concat(parentHeight + 12, "px"); // the height of the parent + the arrow + padding

  var calculatedTopOffset = "".concat(parentHeight + 9, "px"); // the height of the parent + the arrow + padding

  var cornerArrowOffset = "".concat(parentWidth / 2 - 21, "px"); // the difference between half the parent size and the distance from the corner to the middle of the caret

  var style = {
    position: 'absolute',
    bottom: "auto",
    top: "auto",
    left: "auto",
    right: "auto",
    zIndex: zIndex
  };

  if (caretPosition === "bottom-left") {
    style.left = cornerArrowOffset;
    style.bottom = calculatedBottomOffset;
  }

  if (caretPosition === "bottom-center") {
    // shift half the popover content size and then shifted a little more to get to the middle of the parent
    style.transform = "translateX(calc(-50% + ".concat(parentWidth / 2, "px))");
    style.bottom = calculatedBottomOffset;
  }

  if (caretPosition === "bottom-right") {
    style.right = cornerArrowOffset;
    style.bottom = calculatedBottomOffset;
  }

  if (caretPosition === "top-left") {
    style.left = cornerArrowOffset;
    style.top = calculatedTopOffset;
  }

  if (caretPosition === "top-center") {
    // shift half the popover content size and then shifted a little more to get to the middle of the parent
    style.transform = "translateX(calc(-50% + ".concat(parentWidth / 2, "px))");
    style.top = calculatedTopOffset;
  }

  if (caretPosition === "top-right") {
    style.right = cornerArrowOffset;
    style.top = calculatedTopOffset;
  }

  return style;
}